<template>
  <div>
    <v-skeleton-loader
      type="table-thead, table-tbody"
      width="100%"
      :loading="loading"
      boilerplate
    >
      <v-container class="prices-list-table pa-0 fill-height" fluid>
        <v-card width="100%" class="fill-height" color="gray10 pa-5">
          <v-row class="fill-height">
            <v-col cols="12">
              <h1 class="font-Regular-24">{{ $t("assets.title") }}</h1>
            </v-col>
            <v-col cols="12">
              <v-row no-gutters align="center">
                <v-col
                  class="custom-table-card-border d-flex align-center"
                  cols="12"
                  md="5"
                >
                  <div class="font-Regular-12">
                    {{ $t("assets.totalAssets") }}:
                  </div>
                  <div
                    dir="ltr"
                    class="truncate-assets font-Medium-18 ms-1"
                    v-if="showDollar"
                  >
                    {{
                      hideAssets
                        ? "*****"
                        : "$" + " " + $thousandMask(totalUSDT)
                    }}
                  </div>
                  <div
                    dir="ltr"
                    class="truncate-assets font-Medium-18 ms-1"
                    v-else
                  >
                    {{
                      hideAssets
                        ? "*****"
                        : "IRR" + " " + $thousandMask(totalIRR)
                    }}
                  </div>

                  <v-icon
                    @click="() => hideAssetsHandler(false)"
                    size="25"
                    class="ms-1"
                    v-if="hideAssets"
                    >mdi-eye-off-outline
                  </v-icon>
                  <v-icon
                    @click="() => hideAssetsHandler(true)"
                    size="25"
                    class="ms-1"
                    v-else
                    >mdi-eye-outline
                  </v-icon>
                </v-col>
                <v-col class="" cols="12" md="7">
                  <v-row align="center">
                    <v-col cols="12" md="2">
                      <v-switch
                        class="custom-switch"
                        :label="$t('assets.showUsdBalance')"
                        color="primary"
                        value="USD"
                        inset
                        v-model="showDollar"
                      />
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-switch
                        :label="$t('assets.showAvailableAsset')"
                        color="primary"
                        class="custom-switch"
                        inset
                        @change="filterTableData"
                        v-model="showAvailableAsset"
                      />
                    </v-col>

                    <v-col cols="12" md="3">
                      <v-btn
                        @click="convertSmallAssetsModal = true"
                        color="primary"
                        block
                        >{{ $t("assets.smallAssetsModalTitle") }}</v-btn
                      >
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field
                        style="width: 100%;"
                        v-model="searchKey"
                        @input="filterTableData"
                        :placeholder="
                          $vuetify.breakpoint.md ||
                          $vuetify.breakpoint.sm ||
                          $vuetify.breakpoint.mobile
                            ? 'جستجو'
                            : $t('common.searchPlaceHolder')
                        "
                        solo
                        flat
                        hide-details
                        dense
                        height="38"
                        background-color="#00000003"
                        class="custom-price-list-input ms-auto field"
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12">
              <!--Table -->
              <AssetTable
                :dataTable="tableMoneyShow"
                :loading="loading"
                :balanceType="showDollar"
                :hideAssets="hideAssets"
              />
              <!--              <v-col class="py-0 my-3" cols="12">-->
              <!--                <v-row justify="center">-->
              <!--                  <v-col class="py-0 text-center" cols="12">-->
              <!--                    <v-pagination-->
              <!--                      class="custom-number-pagination"-->
              <!--                      v-model="pageNo"-->
              <!--                      :length="pageSize"-->
              <!--                      total-visible="6"-->
              <!--                    ></v-pagination>-->
              <!--                  </v-col>-->
              <!--                </v-row>-->
              <!--              </v-col>-->
            </v-col>
          </v-row>
        </v-card>

        <v-dialog
          content-class="alert-section-card"
          v-model="convertSmallAssetsModal"
          overlay-opacity="0.4"
          overlay-color="#000"
          max-width="500"
        >
          <v-card color="gray10" class="px-5 pb-9 pt-2">
            <div class="gray1--text font-Medium-18 text-center my-6">
              {{ $t("assets.chooseCoin") }}
            </div>

            <div class="text-start mb-2">{{ totalSmallAssets }} $</div>
            <v-data-table
              :class="[
                'prices-data-table table-hover-effect pb-2 pt-1 custom-table gray10',
                $vuetify.rtl ? 'directions-table' : 'ltr-table'
              ]"
              :headers="headers"
              show-select
              v-model="selectItem"
              item-key="unit"
              :items="convertAssetsData"
              :server-items-length="100000"
              locale="fa"
              :no-data-text="$t('common.nodata')"
              :header-props="{ 'sort-icon': null }"
              :height="400"
              class="custom-price-data-table"
              hide-default-footer
            >
              <template v-slot:item.selectAll="{ item }">
                <div class="d-flex align-center">
                  <img width="20" :src="item.coinURL" :alt="item.unit" />
                  <div class="mx-2 gray1--text font-Regular-14">
                    {{ item.unit }}
                  </div>
                  <div class="gray3--text font-Regular-10">
                    ({{ item.localeName }})
                  </div>
                </div>
              </template>

              <template v-slot:item.balance="{ item }">
                <div class="d-flex align-center justify-end">
                  <div class="gray3--text font-Regular-10">
                    {{ item["USD-equivalent"] }} $
                  </div>
                  <div class="mx-2 gray1--text font-Regular-14">~ 0.0</div>
                  <div class="gray1--text font-Regular-14">{{ item.unit }}</div>
                </div>
              </template>
            </v-data-table>

            <v-btn
              :disabled="!selectItem.length"
              @click="convertSmallAssets()"
              style="position: sticky;bottom: 20px"
              min-height="50"
              block
              color="primary"
              >{{ $t("assets.convertSmallAssets") }}</v-btn
            >
          </v-card>
        </v-dialog>
      </v-container>
    </v-skeleton-loader>
  </div>
</template>

<script>
import AssetTable from "@/components/Market/assets/AssetTable.vue";
import { ExchangeService, UserCenterService } from "@/services";
import $thousandMask from "@/mixins/thousandMask";

export default {
  mixins: [$thousandMask],
  components: { AssetTable },
  data() {
    return {
      convertSmallAssetsModal: false,
      totalSmallAssets: 0,
      selectItem: [],
      convertAssetsData: [
        {
          balance: 3,
          unit: "BTC",
          logoUrl:
            "https://api-fa-market-dev.ernyka.com/market/icons/currencies/ETC.png",
          localeName: "بیت کوین"
        },
        {
          balance: 3,
          unit: "LTC",
          logoUrl:
            "https://api-fa-market-dev.ernyka.com/market/icons/currencies/ETC.png",
          localeName: "بیت کوین"
        }
      ],
      headers: [
        {
          text: "انتخاب همه",
          value: "selectAll",
          class: "table-header"
        },
        {
          text: "دارایی",
          value: "balance",
          class: "table-header",
          align: "end" // Right align header
        }
      ],
      totalUSDT: "",
      totalIRR: "",
      GCCMatchAmount: 0,
      matchAmount: 0,
      modal: false,
      loginmsg: this.$t("common.loginTip"),
      loading: true,
      ordKeyword: "",
      tableMoney: [],
      tableMoneyShow: [],
      canMatch: true,
      modal_msg: false,
      match_msg: "",
      searchKey: "",
      tradeBaseCoin: [],
      showDollar: false,
      showAvailableAsset: false,
      hideAssets: false
    };
  },
  created() {
    this.init()
  },
  methods: {
    init(){
      this.getMoney();
      this.getSmallAssetsList();
      this.hideAssets = JSON.parse(localStorage.getItem("hideAssets"));
    },
    getSmallAssetsList() {
      this.totalSmallAssets = 0;
      UserCenterService.getSmallAssetsList().then(res => {
        this.convertAssetsData = res.data.data;
        res.data.data.forEach(item => {
          this.totalSmallAssets += Number(item["USD-equivalent"]);
        });
      });
    },
    convertSmallAssets() {
      let userCoinUnit = this.selectItem.map(item => {
        return item.unit;
      });
      UserCenterService.convertSmallAssets({ userCoinUnit: userCoinUnit }).then(
        () => {
          this.getSmallAssetsList();
          this.convertSmallAssetsModal = false;
          this.init()
        }
      );
    },
    getMoney() {
      UserCenterService.getWalletV2()
        .then(async response => {
          this.totalUSDT = response.data.data.totalUsdBalance;
          this.totalIRR = response.data.data.totalIrrBalance;
          this.tableMoney = response.data.data.walletAssetsResponseDtoList;
          this.getTradeBaseCoins();
        })
        .catch(err => {
          this.$toast.error(err.message);
        });
    },
    getTradeBaseCoins() {
      ExchangeService.getAllTradeBaseCoin()
        .then(async response => {
          let baseDate = {};
          baseDate = await response.data.data;
          for (let item in this.tableMoney) {
            for (let elem in baseDate) {
              if (this.tableMoney[item].unit === elem) {
                this.tableMoney[item]["baseCoinList"] = await baseDate[elem];
              }
            }
            if (!this.tableMoney[item]["baseCoinList"]) {
              this.tableMoney[item]["baseCoinList"] = [];
            }
          }
          this.tableMoneyShow = this.tableMoney;

          // for (let i = 0; i < this.tableMoney.length; i++) {
          //     this.tableMoney[i]["coinType"] = this.tableMoney[i].coin.unit;
          // }
          // else {
          //   this.$Message.error(this.loginmsg);
          // }
        })
        .finally(() => {
          this.loading = false;
        })
        .catch(err => {
          this.$toast.error(err.message);
        });
    },
    filterTableData() {
      this.searchKey = this.searchKey.toUpperCase();
      this.tableMoneyShow = this.tableMoney.filter(
        item => {
          if (this.showAvailableAsset) {
            return (
              item.strBalance > 0 &&
              (item["unit"].includes(this.searchKey) ||
                item["name"].toUpperCase().includes(this.searchKey))
            );
          } else {
            return (
              item["unit"].includes(this.searchKey) ||
              item["name"].toUpperCase().includes(this.searchKey)
            );
          }
        }
        // this.showAvailableAsset
        //   ? item.strBalance > 0 &&
        //     (item["unit"].includes(this.searchKey.toUpperCase()) ||
        //       item["name"].toUpperCase().includes(this.searchKey.toUpperCase()))
        //   : item["unit"].includes(this.searchKey.toUpperCase()) ||
        //     item["name"].toUpperCase().includes(this.searchKey.toUpperCase())
      );
    },
    hideAssetsHandler(show) {
      this.hideAssets = show;
      localStorage.setItem("hideAssets", JSON.stringify(show));
    }
  }
};
</script>

<style lang="scss" scoped></style>
